module.exports = __webpack_public_path__ + "loader.ac7503d8215fa3d18d7f.gif";


//////////////////
// WEBPACK FOOTER
// /Users/numherit/PhpstormProjects/TEMPLATES/sunuprojet/src/assets/images/loader.gif
// module id = ../../../../../src/assets/images/loader.gif
// module chunks = styles